import { Button, Icon, Tooltip, Box, Typography } from '@material-ui/core';
import InsertLinkIcon from '@material-ui/icons/InsertLink';
import PermissionHide from 'components/PermissionHide';
import React from 'react';
import { CHECKOUT_ELEMENTS_URL, CHECKOUT_SUN_URL } from 'settings';

import styles from './styles';

import type IProduct from 'interfaces/IProduct';
import type { ICheckoutsUrls } from 'scenes/Producer/MyCampaigns';

interface IProps {
  currentProduct: IProduct;
  openUrlCreatorCheckout: (urls: ICheckoutsUrls) => void;
  openTrackerForm: () => void;
  classes: any;
}

const AdvancedConfigsUrls = ({ currentProduct, openUrlCreatorCheckout, openTrackerForm, classes }: IProps) => {
  return (
    <Box className={classes.container}>
      <Typography className={classes.title}>Configurações Avançadas</Typography>
      <Box className={classes.content}>
        <PermissionHide action='myeduzz:links:editar'>
          <Box>
            <Button
              onClick={() => {
                openUrlCreatorCheckout({
                  linkSun: `${CHECKOUT_SUN_URL}/${currentProduct.id}`,
                  linkChk: `${CHECKOUT_ELEMENTS_URL}/${currentProduct.id}`,
                });
              }}
              variant='outlined'
              fullWidth
              style={{ height: '3.125rem', border: '1px solid #000' }}
            >
              <InsertLinkIcon fontSize='small' />
              <p className={classes.btnText}>Gerador de UTM</p>
            </Button>
          </Box>
        </PermissionHide>

        <PermissionHide action='myeduzz:links:editar'>
          <Box>
            {currentProduct.can_create_pixel && (
              <Tooltip title='O pixel deve ser cadastrado no produto principal' disableHoverListener={!!currentProduct.parent_product}>
                <span>
                  <Button
                    disabled={!!currentProduct.parent_product}
                    id='trackCampaignButton'
                    fullWidth
                    variant='outlined'
                    onClick={openTrackerForm}
                    style={{ height: '3.125rem', border: '1px solid #000' }}
                  >
                    <Icon style={{ fontSize: 20, color: '#000' }}>code</Icon>
                    <p className={classes.btnText}>Pixel de Conversão</p>
                  </Button>
                </span>
              </Tooltip>
            )}
          </Box>
        </PermissionHide>
      </Box>
    </Box>
  );
};

export default styles(AdvancedConfigsUrls) as any;
